import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '@/features/dialog/dialogSlice';
import CreateRelationshipContactForm from '@/components/forms/CreateRelationshipContactForm';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';
import EditRelationshipContact from './EditRelationshipContact';

export const RelationshipContactDrawer = () => {
	const dispatch = useDispatch();
	const open = useSelector((state) => state.dialog?.open?.relationshipContact);
	const contactId = useSelector((state) => state.dialog?.data?.relationshipContact?.contactId);
	const isEdit = Boolean(contactId);

	const handleClose = () => {
		dispatch(closeDialog('relationshipContact'));
	};

	return (
		<FolioDrawer open={open} onClose={handleClose} size='narrow'>
			{open &&
				(isEdit ? (
					<EditRelationshipContact contactId={contactId} onClose={handleClose} />
				) : (
					<CreateRelationshipContactForm dialogView onSubmit={handleClose} />
				))}
		</FolioDrawer>
	);
};
